import React from 'react';
import 'react-dom';
import '../../_rollupPluginBabelHelpers-2e5b701d.js';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import '../../index-930c2100.js';
import '../../hooks/useActivify.js';
import '../../index-efb29065.js';
import '../../key_codes-a5a2b85e.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import '../../style-inject.es-1f59c1d0.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import '../box.js';
import { g as getObjectValue } from '../../util-cc00ee1d.js';
import '../../index.esm-f8e9e79f.js';
import '@styled-system/grid';
import '@styled-system/background';
import { I as IconWrapper } from '../../IconWrapper-eb05d1ed.js';

var CloseIconV4 = function CloseIconV4(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM7.79289 7.79289C8.18342 7.40237 8.81658 7.40237 9.20711 7.79289L12 10.5858L14.7929 7.79289C15.1834 7.40237 15.8166 7.40237 16.2071 7.79289C16.5976 8.18342 16.5976 8.81658 16.2071 9.20711L13.4142 12L16.2071 14.7929C16.5976 15.1834 16.5976 15.8166 16.2071 16.2071C15.8166 16.5976 15.1834 16.5976 14.7929 16.2071L12 13.4142L9.20711 16.2071C8.81658 16.5976 8.18342 16.5976 7.79289 16.2071C7.40237 15.8166 7.40237 15.1834 7.79289 14.7929L10.5858 12L7.79289 9.20711C7.40237 8.81658 7.40237 8.18342 7.79289 7.79289Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  })));
};
CloseIconV4.propTypes = {
  iconColor: PropTypes.string
};
CloseIconV4.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CloseIconV4",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var CloseIconV4$1 = withTheme(CloseIconV4);

export default CloseIconV4$1;
